import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
} from '@angular/router';
import { appRoutes } from './app.routes';
import {
  provideHttpClient,
  withInterceptors,
  HttpClient,
} from '@angular/common/http';
import { provideEffects } from '@ngrx/effects';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { ConfigEffects } from './store/config/config.effects';
import { rootReducers } from './store/index.reducers';
import { LoginEffects } from './store/login/login.effects';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { authInterceptor } from './utils/interceptor';
import { ThirdPartyReportEffects } from './store/third-party-report/third-party-report.effects';
import { AnagraphicEffects } from './store/anagraphic/anagraphic.effects';
import { RendicontazioniEffects } from './store/rendicontazione/rendicontazione.effects';
import { MonitoringEffects } from './store/monitoring/monitoring.effects';
import { UtilitiesEffects } from './store/utilities/utilities.effects';
import { CommunicationEffects } from './store/communication/communication.effects';
import { MassiveUploadEffects } from './store/massive-upload/massive-upload.effects';
//139172 – Tool per la rilevazione stato del PuntoPoste
import { ClusterEffects } from './store/cluster/cluster.effects';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    './assets/i18n/',
    `.json?${new Date().getTime()}`
  );
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withComponentInputBinding(),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideEffects([
      ConfigEffects,
      LoginEffects,
      ThirdPartyReportEffects,
      AnagraphicEffects,
      RendicontazioniEffects,
      MonitoringEffects,
      UtilitiesEffects,
      CommunicationEffects,
      MassiveUploadEffects,
      UtilitiesEffects,
      ClusterEffects,
    ]),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideStore(rootReducers),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'it',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
  ],
};
